import { Stack } from "@fluentui/react";
import { DEFAULT_USE_CASE_NAME } from "../../utils/constants";
import CardGroup from "../Cards/CardGroup";

import EuCo from "../../assets/EuCo.svg";
import styles from "./ChatLander.module.css";
import { CHAT_INCENTIVE, CHAT_NAME, LOADING_TEXT } from "./constants";

interface ChatLanderProps {
  visualUseCase: string;
  isAssistantAPILoading: boolean;
  handleSelectUseCase: (
    title: string,
    key: string,
    confirmationMessage?: string,
  ) => void;
}

const ChatLander = ({
  visualUseCase,
  isAssistantAPILoading,
  handleSelectUseCase,
}: ChatLanderProps) => {
  return (
    <Stack className={styles.chatEmptyState}>
      <img
        src={EuCo}
        className={styles.chatIcon}
        aria-hidden="true"
        alt="INTPA AI Assistant"
      />
      <>
        <h1 className={styles.chatEmptyStateTitle}>{CHAT_NAME}</h1>
        <h2 className={styles.chatEmptyStateSubtitle}>{CHAT_INCENTIVE}</h2>
      </>
      {visualUseCase == DEFAULT_USE_CASE_NAME && (
        <CardGroup
          isAssistantAPILoading={isAssistantAPILoading}
          onCardClick={(title, key, confirmationMessage) => {
            handleSelectUseCase(title, key, confirmationMessage);
          }}
        />
      )}
      {isAssistantAPILoading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingIcon}></div>
          <p>{LOADING_TEXT}</p>
        </div>
      )}
    </Stack>
  );
};

export default ChatLander;
